<template>
    <div class="CS">

        <v-container class="py-0">

            <!-- Desktop View -->
            <v-row v-if="screenWidth > 599" class="desktop-view">
                <v-col cols="6" class="py-0">

                    <v-row align="center" style="height:calc(100vh - 120px)">
                        <v-col>
                            <template v-for="(category,c) in categories">
                                <div :key="'img-c-'+c">

                                    <transition name="fade-transition" mode="out-in" >
                                        <v-img :src="'https://artlesscms.actstudio.xyz/'+category.cover.path" v-show="c == activeCategory && categorySelected == null"></v-img>
                                    </transition>


                                    <template v-for="(product, p) in products">
                                        <transition name="fade-transition" mode="out-in" :key="'product-image-n'+p">

                                            <v-img :src="'https://artlesscms.actstudio.xyz/'+product.cover.path" v-show="categorySelected == c && productSelected == p"></v-img>

                                        </transition>
                                    </template>
                                </div>
                            </template>
                        </v-col>
                    </v-row>

                    <div style="position: absolute; width: 0px; height:0px; overflow: hidden;">
                        <template v-for="(category,c) in categories">
                            <img :src="'https://artlesscms.actstudio.xyz/'+category.cover.path" :key="'img-c-nn'+c">
                        </template>
                    </div>
                </v-col>
                <v-col cols="6" class="pl-0">

                    <template v-if="loaded && loaded2">
                        
                        <full-page ref="fullpage" :options="options" id="fullpage" v-model="a">
                            <template v-for="(category,c) in categories">
                                <div class="section" :key="'section-'+c">
                                    <v-row style="height: calc(100vh -  60px);" align="center">
                                        <v-col>
                                            <div class="px-12 py-6" style="border-left: 2px solid #979797; min-height: 600px;">
                                                <div class="pl-12">

                                                    
                                                    <span class="uppercase CSCategoryTitle">{{category.name}}</span>

                                                    <template v-for="(product,p) in products">
                                                        <template v-if="category._id == product.category._id">
                                                            <div @mouseover="categorySelected = c; productSelected = p;" @mouseout="categorySelected = null; productSelected = null;" :key="'product-'+p">

                                                                <router-link :to="'/CS/product/'+product.url" class="d-block CSProductName uppercase not-text-decoration color-cs-2 pb-3">{{product.name}}</router-link>
                                                            </div>
                                                        </template>
                                                    </template>
                                                </div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </div>
                            </template>
                        </full-page>
                    </template>
                </v-col>
            </v-row>

            <div class="mobile-view" v-if="screenWidth < 600">
                <template v-for="(category,c) in categories">
                    <div class="mb-12" :key="'category-mo-'+c">
                        <v-row>
                            <v-col class="text-center">
                                <span class="uppercase CSCategoryTitle">{{category.name}}</span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-img :src="'https://artlesscms.actstudio.xyz/'+category.cover.path"></v-img>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <template v-for="(product,p) in products">
                                    <template v-if="category._id == product.category._id">
                                        <router-link :to="'/CS/product/'+product.url" class="d-block CSProductName uppercase not-text-decoration color-cs-2 pb-3" :key="'CSCategory-'+c+'-'+p">{{product.name}}</router-link>
                                    </template>
                                </template>
                            </v-col>
                        </v-row>
                    </div>
                </template>
            </div>
        </v-container>

        
    </div>    
</template>

<script>
import Vue from 'vue'
import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
import VueFullPage from 'vue-fullpage.js'

Vue.use(VueFullPage);

export default {
    data(){
        return{
            categories:[],
            products: [],
            categorySelected: null,
            productSelected: null,
            options: {
                onLeave: this.onLeave,
                verticalCentered: true
            },
            loaded: false,
            loaded2: false,
            activeCategory: 0
        }
    },
    computed:{
        screenWidth: function(){
            return this.$vuetify.breakpoint.width;
        }
    },
    beforeMount: function(){
        fetch('https://www.artlesscms.actstudio.xyz/api/collections/get/CSCategory?token=a15be93e9cdb43ca2b3778c2077c26', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                populate: 2
            })
        })
        .then(res=>res.json())
        .then(res => this.categories = res.entries )
        .then(()=>this.loaded = true);


        fetch('https://www.artlesscms.actstudio.xyz/api/collections/get/CSProduct?token=a15be93e9cdb43ca2b3778c2077c26', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                populate: 2,
                filter: { active: true }
            })
        })
        .then(res=>res.json())
        .then(res => this.products = res.entries )
        .then(()=>this.loaded2 = true);
    },
    methods:{
        onLeave: function(from, to){
            this.activeCategory = to.index;
            this.categorySelected = null;
            //alert(to.index)
        },
        moveSlider: function(){

            if(this.$route.params.url != undefined){
                var index = this.categories.findIndex(element => element.url == this.$route.params.url);
                this.$refs.fullpage.api.moveTo(index + 1);
            }
        }
    },
    mounted: function(){
        this.$emit("update", 1);
        var aux = this;
        setTimeout(() => {
            aux.moveSlider();
        }, 1000);

        var breadcrumbs = [
            // {
            //     text: 'Home',
            //     link: '/',
            //     isLink: true
            // },
            // {
            //     text: 'CS',
            //     link: '/cs',
            //     isLink: false
            // }
        ];
        this.$emit("updateStatus", breadcrumbs);
        gtag('config', 'UA-26953667-1', {
            'page_title' : 'CS',
            'page_path': '/cs'
        });
    }
}
</script>